export default {
    NEW_HOME: 'new-home',
    RENEWAL: 'policy-renewal',
    BROWSING: 'browsing',
};
